import { defineAppConfig } from '@zto/zpage'

import { loadAreas } from '../../utils/area'

import header from './header'
import board from './board'

import type { App, AppAppConfig } from '@zto/zpage'

export default defineAppConfig<AppAppConfig>((app: App) => {
  return {
    menu: {
      showNav: true,
      maxNavs: 15,
      homeMenu: true
    },
    header,
    board,
    auth: {
      loader: 'iam',
      token: {
        // autoRefresh: false // 自动刷新token
        // refreshDuration: 600 // accessToken刷新频率（默认60分钟）
      }
    },
    // page: { loader: 'local' },
    onLoad: async () => {
      await loadAreas(app)
    }
  }
})
